import { type CollectionModel, CollectionModelFieldTrueSize } from '@ikegps/core-shared';
import { T, Translate } from '../../../i18n';
import { AppStore } from '../../../store';
import { ImageWithTitle } from '../components/ImageWithTitle';
import { TitleBar } from '../components/TitleBar';
import { captureReferenceString, compositeURL, hasUserMeasurement, isCaptureHidden } from '../ReportHelpers';
import { ReportBase } from './ReportBase';

export class ReportCompositePhotoOnly extends ReportBase {
	constructor(poles: CollectionModel[]) {
		super(poles);
	}

	buildPDF(): void {
		this.poles.forEach((pole, i) => {
			const job = AppStore.Tag.get(pole.jobId);

			pole.forEachField((field) => {
				// Truesize images
				if (field instanceof CollectionModelFieldTrueSize) {
					const captures = field.getOwnedCaptures();
					captures.forEach((capture) => {
						if (!isCaptureHidden(pole, capture.objectId)) {
							if (hasUserMeasurement(pole, capture.objectId)) {
								const imageReferenceString = captureReferenceString(pole, capture);
								this.images[imageReferenceString] = compositeURL(pole, capture);
								// Title
								this.nodes.push(
									new TitleBar(pole.title || Translate(T.COLLECTION_MISSING_TITLE), job.name, i + 1, this.poles.length)
								);
								// Image
								this.nodes.push(new ImageWithTitle(field.schema.displayName, { reference: imageReferenceString }));
							}
						}
					});
				}
			});
		});
	}
}
